export const letterGenreValues = [
  { value: 0, name: "選択してください" },
  { value: 1, name: "商談獲得" },
  { value: 2, name: "ウェビナー" },
  { value: 3, name: "資料請求" },
];

export const keywordsMaxSize = 10;

export const initialKeywords = {
  0: '',
  1: '',
  2: '',
  3: '',
  4: '',
}



// WEBPACK FOOTER //
// ./src/constants/LetterAIValues.js